import { render, staticRenderFns } from "./HowMuch.vue?vue&type=template&id=faed4814&"
import script from "./HowMuch.vue?vue&type=script&lang=js&"
export * from "./HowMuch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports